import { FunctionComponent, useEffect, useState } from 'react'
import { useQuery } from '@apollo/client'
import styles from './blacklist.module.scss'
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import { GET_BLACKLIST } from '@/modules/API/software/blacklist'
import Title from '@/components/_custom/Title/title'
import { useTranslation } from 'react-i18next'
import Loading from '@/components/Loading/Loading'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { Delete, Edit } from '@mui/icons-material'
import ConfirmDeleteBlacklistDialog from './Dialog/confirmDeleteBlacklistDialog'
import EditBlacklist from './Dialog/editBlacklist'

const BlackListSettings: FunctionComponent = () => {
    const { t } = useTranslation()

    const [blacklist, setBlacklist] = useState<Array<string>>([])

    const [blacklistElement, setBlacklistElement] = useState<string>('')
    const [create, setCreate] = useState<boolean>(false)

    const [isDeleteDialogOpen, setDeleteDialogOpen] = useState<boolean>(false)
    const [isEditDialogOpen, setEditDialogOpen] = useState<boolean>(false)

    const { loading: loadingBlacklist, data: dataBlacklist } = useQuery(GET_BLACKLIST)

    useEffect(() => {
        if (dataBlacklist) {
            setBlacklist(dataBlacklist.getBlacklist || [])
        }
    }, [dataBlacklist])

    function handleDeleteBlacklistElement(e: string): void {
        setBlacklistElement(e)
        setDeleteDialogOpen(true)
    }

    function removeBlacklistElement(e: string): void {
        const newBlacklist: string[] = blacklist.filter((value: string): boolean => value !== e)
        setBlacklist(newBlacklist)
    }

    function handleAddBlacklistElement(): void {
        setCreate(true)
        setBlacklistElement('')
        setEditDialogOpen(true)
    }

    function addBlacklistElement(value: string): void {
        const newBlacklist: string[] = [...blacklist, value]
        setBlacklist(newBlacklist)
    }

    function handleUpdateBlacklistElement(e: string): void {
        setBlacklistElement(e)
        setCreate(false)
        setEditDialogOpen(true)
    }

    function updateBlacklistElement(oldEmail: string, newEmail: string): void {
        const newBlacklist: string[] = blacklist.map((value: string): string => (value === oldEmail ? newEmail : value))
        setBlacklist(newBlacklist)
    }

    return (
        <div className={styles.BlackListPlacement}>
            <div className={styles.Form}>
                <div className={styles.TitleAndButton}>
                    <Title text={t('blacklist')} className={styles.Title} />
                    <ButtonTextIcon type={'add'} onClick={handleAddBlacklistElement} />
                </div>
                {loadingBlacklist && <Loading overall={false} />}
                {dataBlacklist && (
                    <Table className={styles.TableComponent}>
                        <TableHead className={styles.TableHeader}>
                            <TableRow>
                                <TableCell sx={{ width: '70%' }}>{t('domains')}</TableCell>
                                <TableCell sx={{ width: '30%' }} align={'center'}>
                                    {t('actions')}
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {blacklist.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={2}>{t('noBlacklist')}</TableCell>
                                </TableRow>
                            ) : (
                                blacklist.map((value, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{value}</TableCell>
                                        <TableCell align={'center'}>
                                            <Edit
                                                className={styles.Icon}
                                                onClick={() => handleUpdateBlacklistElement(value)}
                                            />
                                            <Delete
                                                className={styles.Icon}
                                                onClick={() => handleDeleteBlacklistElement(value)}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                )}
            </div>
            <ConfirmDeleteBlacklistDialog
                open={isDeleteDialogOpen}
                handleClose={() => setDeleteDialogOpen(false)}
                email={blacklistElement}
                deleteBlacklist={removeBlacklistElement}
            />
            <EditBlacklist
                create={create}
                handleClose={() => setEditDialogOpen(false)}
                open={isEditDialogOpen}
                email={blacklistElement}
                addBlacklistElement={addBlacklistElement}
                updateBlacklistElement={updateBlacklistElement}
            />
        </div>
    )
}

export default BlackListSettings
